import { useRef, useState } from "react";
import { Paperclip, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadFile, errMsg } from "@/lib/api";
import { AuthImage } from "@/components/common";
import { usePrefs } from "@/lib/context";

export function PhotoUpload({ value, onChange, testId = "photo-upload", accept = "image/*,application/pdf" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const { t } = usePrefs();
  const pick = async (e) => {
    const files = [...e.target.files];
    if (!files.length) return;
    setBusy(true);
    try {
      const done = [];
      for (const f of files) done.push((await uploadFile(f)).path);
      onChange([...(value || []), ...done]);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      {(value || []).map((p) => (
        <div key={p} className="relative h-14 w-14 overflow-hidden rounded-sm border">
          {p.endsWith(".pdf") ? <div className="flex h-full items-center justify-center bg-slate-100 text-[10px] font-semibold">PDF</div> : <AuthImage path={p} className="h-full w-full object-cover" />}
          <button type="button" onClick={() => onChange(value.filter((x) => x !== p))} className="absolute right-0 top-0 bg-slate-900/70 p-0.5 text-white"><X size={10} /></button>
        </div>
      ))}
      <button type="button" data-testid={testId} onClick={() => ref.current.click()} className="flex h-14 items-center gap-2 rounded-sm border border-dashed border-slate-300 px-3 text-xs text-slate-600 transition-colors hover:border-[#B8860B] hover:text-[#996515]">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Paperclip size={14} />} {t("upload")}
      </button>
      <input ref={ref} type="file" multiple accept={accept} className="hidden" onChange={pick} data-testid={`${testId}-input`} />
    </div>
  );
}
